import { Stack, Typography } from '@mui/material'

import {
  PriceActiveLine,
  PriceProductList,
  PriceProductListFullPrice,
} from '@/components/ProductPrice/ProductPrice.styled'
import { SmallestUnitPrice } from '@/components/ProductPrice/SmallestUnitPrice'
import { PriceLabelEnum } from '@/enums/PriceLabelEnum'
import { getPriceMarkers } from '@/helpers/getPriceMarkers'
import { useTenant } from '@/hooks/useTenant'
import { useTranslations } from '@/hooks/useTranslations'
import { commerceTheme as theme } from '@/themes/commerce/theme'

import type React from 'react'
import type { getBffPrices } from '@/helpers/getBffPrices'

interface Props {
  price?: ReturnType<typeof getBffPrices>
  isLoading?: boolean
}

export const ProductListPrice: React.FC<Props> = ({ price, isLoading = false }) => {
  const { translate } = useTranslations()
  const tenant = useTenant()

  const { fullPrice } = getPriceMarkers(price ?? null, tenant.currency, tenant.locale)

  return (
    <Stack sx={{ width: '100%' }}>
      {isLoading ? (
        <>
          {fullPrice && <PriceProductListFullPrice />}
          <PriceProductList />
        </>
      ) : (
        <>
          {fullPrice && (
            <Typography
              component="p"
              sx={{ color: theme.palette.text.placeholder, lineHeight: '1rem' }}
              variant="body2"
            >
              {translate(`productDetails.listPrice`)}
              <Typography component="span" sx={{ textDecoration: 'line-through' }}>
                {fullPrice}
              </Typography>
            </Typography>
          )}
          <div className="flex items-baseline gap-2">
            <PriceActiveLine
              sx={{
                fontSize: '16px',
                textAlign: 'left',
                width: 'auto',
                color:
                  fullPrice || price?.priceType === PriceLabelEnum.CAMPAIGN
                    ? theme.palette.text.campaignPrice
                    : theme.palette.text.primary,
              }}
              variant="body1"
            >
              {price?.formattedValue}
            </PriceActiveLine>
            <SmallestUnitPrice smallestUnitPrice={price?.smallestUnitPrice} />
          </div>
        </>
      )}
    </Stack>
  )
}
